import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  loadPlaygroundInitialState,
  saveSiteTokenDetailsToStorage,
} from './utils';

export interface SiteTokenDetails {
  metaSiteId?: string;
  name?: string;
  token?: string;
  expiryTime?: number;
}

export interface PlaygroundState {
  data: {
    selectedSiteTokenDetails: SiteTokenDetails;
  };
  status: 'idle' | 'loading' | 'failed';
}

export const playgroundInitialState: PlaygroundState = {
  data: {
    selectedSiteTokenDetails: {},
  },
  status: 'idle',
};

export const playgroundSlice = createSlice({
  name: 'playground',
  initialState: loadPlaygroundInitialState(),
  reducers: {
    setSelectedSiteTokenDetails: (
      state,
      action: PayloadAction<{ selectedSiteTokenDetails: SiteTokenDetails }>,
    ) => {
      saveSiteTokenDetailsToStorage(action.payload.selectedSiteTokenDetails);
      state.data.selectedSiteTokenDetails =
        action.payload.selectedSiteTokenDetails;
    },
  },
});

export default playgroundSlice.reducer;
